module.exports = __webpack_public_path__ + "static/media/vtrash.92412a11.svg";